import React, { FC } from 'react';
import { Wrapper } from './styles';
import { Header, LayoutComponent } from './components';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const AdminEdit: FC = () => {
  const { isExpiredSoon, isBlocked } = useSubscription();

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <Header />

      <LayoutComponent />
    </Wrapper>
  );
};

export default AdminEdit;
